import '../css/before.css'

export const Before = () => {
    return (
        <div className="beforeMain">
            <div className="animateBox">
                <div className="animateDots">
                    <div className="dotBox">
                        <div className="dotOne"></div>
                    </div>
                    <div className="dotBox">
                        <div className="dotTwo"></div>
                    </div>
                    <div className="dotBox">
                        <div className="dotThree"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}